<template>
    <b-container fluid class="animated fadeIn">
        <h1>Exibir Histórico de CDA</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Dados Gerais" active>
                            <b-row class="mb-2">
                                <b-col class="mb-3 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div class="text-center title">
                                        Dados da CDA
                                    </div>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Número:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.numeroDivida }}</label>
                                    </b-form>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data da Inscrição:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.dtInscricao }}</label>
                                    </b-form>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Total:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.valor ? cda.valor : 0 | currency }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Tipo de Crédito:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.tipoCredito }}</label>
                                    </b-form>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Origem:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.origem }}</label>
                                    </b-form>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Status FIR:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.statusFir }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data atualização:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.dtAtualizacao }}</label>
                                    </b-form>
                                </b-col>
                                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Base Principal:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.dataBasePrincipal }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Base Juros:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.dataBaseJuros }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Principal Atual:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.valorPrincipal ? cda.valorPrincipal : '' | currency }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Multa Atual:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.valorMulta ? cda.valorMulta : 0 | currency }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form inline>
                                        <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Juros Atual:</label>
                                        <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.valorJuros ? cda.valorJuros : 0 | currency }}</label>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mb-0">
                                <b-col class="mb-0 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div class="text-center title">
                                        Dados do Devedor
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="border-sub">
                                    <b-row class="mb-0">
                                        <b-col class="mb-3 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                            <div class="text-center sub-title">
                                                Principal
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Nome:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.nome }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CPF/CNPJ:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.cpfCnpj | cpfCnpj }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CAD/ICMS:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.cadicms }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Status CAD/ICMS:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.statusCadicms }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Endereço:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.endereco }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CEP:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.cep | cep }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Bairro:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.endereco }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Município:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.municipio == null ? '' : cda.devedorPrincipal.municipio.nome }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">UF:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorPrincipal.municipio == null ? '' : cda.devedorPrincipal.municipio.uf }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                    <b-row class="mb-2">
                                        <b-col class="mb-3 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                            <div class="text-center sub-title"  style="margin-left: -1px;">
                                                Alternativo
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Nome:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorAlternativo.nome: '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CPF/CNPJ:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.cpfCnpj : '' | cpfCnpj }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CAD/ICMS:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.cadicms : '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Status CAD/ICMS:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.statusCadicms: '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Endereço:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.endereco : '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">CEP:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.cep : '' | cep }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Bairro:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? cda.devedorPrincipal.endereco : '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Município:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? (cda.devedorPrincipal.municipio == null ? '' : cda.devedorPrincipal.municipio.nome) : '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">UF:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.devedorAlternativo ? (cda.devedorPrincipal.municipio == null ? '' : cda.devedorPrincipal.municipio.uf) : '' }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="mb-0">
                                <b-col class="mb-0 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div class="text-center title">
                                        Histórico
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="border-sub">
                                    <b-row class="mb-0">
                                        <b-col class="mb-3 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                            <div class="text-center sub-title">
                                                Ajuizamento
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Número Autos:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.numeroAutos }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Comarca:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.comarca }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Juízo:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.juizo }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Autuação:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.dataAtuacao }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Distribuição:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.dataDistribuicao }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Procurador:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.ajuizamento.procurador }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Total:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{cda.ajuizamento.valorTotal ? cda.ajuizamento.valorTotal : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Principal:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.ajuizamento.valorPrincipal ? cda.ajuizamento.valorPrincipal : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Multa:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.ajuizamento.valorMulta ? cda.ajuizamento.valorMulta : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Juros:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.ajuizamento.valorJuros ? cda.ajuizamento.valorJuros : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                    <b-row class="mb-2">
                                        <b-col class="mb-3 p-0" xs="12" sm="12" md="12" lg="12" xl="12">
                                            <div class="text-center sub-title"  style="margin-left: -1px;">
                                                Protesto
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Comarca:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.comarca }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Tabelionato:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.tabelionato }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Envio Protesto (EPP):</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.dataEnvioProtesto }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Apontamento (APT):</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.dataApontamento }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Protesto:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.dataProtesto }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Procurador:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.procurador }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Total:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.protesto.valorTotal ? cda.protesto.valorTotal : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Principal:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.protesto.valorPrincipal ? cda.protesto.valorPrincipal : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Multa:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.protesto.valorMulta ? cda.protesto.valorMulta : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Valor Juros:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">R$ {{ cda.protesto.valorJuros ? cda.protesto.valorJuros : 0 | currency }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Carta:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.dataCartaAnuencia }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Arquivo Carta:</label>
                                                <label class="mr-sm-2 sublinhado link" for="inline-form-custom-select-pref" @click.prevent="downloadCartaAnuencia">{{ cda.protesto.arquivoCartaAnuencia }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Situação:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.situacao }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Ocorrência:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.ocorrencia }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Retorno:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.retorno }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Irregularidade:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.irregularidade }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Pedido de Cancelamento:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.pedidoCancelamento }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                            <b-form inline>
                                                <label class="mr-sm-2 negrito" for="inline-form-custom-select-pref">Data Pedido Cancelamento:</label>
                                                <label class="mr-sm-2" for="inline-form-custom-select-pref">{{ cda.protesto.dataPedidoCancelamento }}</label>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Eventos">
                            <b-row class="justify-content-md-center">
                                <h3>CDA: {{ cda.numeroDivida }}</h3>
                            </b-row>
                            <template v-if="cda.listaEventos.length">
                                <Timeline v-for="item in cda.listaEventos" :key="item.ano" :data="item" />
                            </template>
                            <template v-else>
                                <b-row class="justify-content-md-center">
                                    <label>Nenhum evento registrado.</label>
                                </b-row>
                            </template>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <div class="d-flex justify-content-between mb-3">
                    <div>
                        <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i> Voltar</b-button>
                        <b-button class="mx-1 fonte-branca" @click.prevent="relatorioPDF" style="float:right; height: 35px" variant="primary"><i class="fa fa-file-pdf-o" v-if="!loadPDF"></i>
                            <b-spinner small v-if="loadPDF"></b-spinner> Imprimir Extrato da CDA</b-button>
                    </div>
                </div>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
    </b-container>
</template>

<script>
import axios from 'axios'
import Timeline from '../shared/components/timeline/Timeline';
import CompLoading from "../shared/components/CompLoading";
export default {
    name: 'ConsultarCDAExibir',
    components: {
        Timeline, CompLoading
    },
    data() {
        return {
            loading: true,
            codCdaSefa: null,
            loadPDF: false,
            cda: {
                devedorPrincipal: {
                    municipio: {}
                },
                devedorAlternativo: {
                    municipio: {}
                },
                ajuizamento: {
                    numeroAutos: null,
                    comarca: null,
                    juizo: null,
                    dataAtuacao: null,
                    dataDistribuicao: null,
                    procurador: null,
                    valorTotal: null,
                    valorPrincipal: null,
                    valorMulta: null,
                    valorJuros: null,
                },
                protesto: {
                    comarca: null,
                    tabelionato: null,
                    dataEnvioProtesto: null,
                    dataApontamento: null,
                    dataProtesto: null,
                    procurador: null,
                    valorTotal: null,
                    valorPrincipal: null,
                    valorMulta: null,
                    valorJuros: null,
                    dataCartaAnuencia: null,
                    arquivoCartaAnuencia: null,
                    codigoCartaAnuencia: null,
                    situacao: null,
                    ocorrencia: null,
                    retorno: null,
                    irregularidade: null,
                    pedidoCancelamento: null,
                    dataPedidoCancelamento: null,
                },
                listaEventos: []

            },
        }
    },
    methods: {
        async downloadCartaAnuencia() {
            const { protesto } = this.cda
            const { codigoCartaAnuencia } = protesto

            if(codigoCartaAnuencia) {

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).access_token

                await axios.post(`${urlApi}/v1/consultarCdas/obterPdfCartaExibir`, codigoCartaAnuencia, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    if(!response.data || !response.data.byteLength){
                        this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                        window.scrollTo(0,0);
                        return;
                    }

                    let blob = new Blob([response.data], { type: 'application/pdf' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'carta-anuencia.pdf'
                    link.click()
                }).catch((error) => {
                    this.exibirErro(error)
                })
            }
        },

        voltar() {
            this.$store.commit("setCDA", null);
            this.$store.commit("setRecoverFilterCDA", true);
            this.$router.push({ path: '/consultar-cdas' })
        },

        async obterCda(codCdaSefa) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            this.$refs.loading.showLoading();
            await axios.post(`${urlApi}/v1/consultarCdas/obter`, codCdaSefa, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.cda = response.data
                if(this.cda.outrosDevedores.length) {
                    this.cda.devedorAlternativo = this.cda.outrosDevedores[0]
                }
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => this.$refs.loading.hideLoading());
        },

        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        async relatorioPDF() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadPDF = true
            axios.get(`${urlApi}/v1/consultarCdas/exportarPdfCda/${this.codCdaSefa}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'RelatorioCda' + this.cda.numeroDivida + '.pdf';
                link.click();
            }).finally(() => {
                this.loadPDF = false
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});
        this.codCdaSefa = this.$route.params.id
        this.obterCda(this.codCdaSefa);

    }
}
</script>

<style scoped>

.negrito {
    font-weight: bold;
}

.title {
    background-color: #20A8D8;
    color: #FFF;
    font-weight: bold;
    padding: 6px 0px 6px 0px;
}
.sub-title {
    background-color: #004262;
    color: #FFF;
    font-weight: bold;
    padding: 6px 0px 6px 0px;
}

.sublinhado {
    text-decoration: underline;
}

.border-sub {
    border-right: 1px solid #CECECE;
}
</style>